import { CACHE_FIRST, ENTITY_PATH, ENTITY_PATH_ID } from 'contracts/constants';
import { BASE_PAGE_TITLE } from 'contracts/constants/page-title';
import type { FC } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { useGetPackageQuery } from 'services/graphql/generated/hooks';
import { getParams } from 'utils';

export const BaseHelmet: FC<{ page: string }> = ({ page }) => {
  const { pathname } = useLocation();
  const params: { [key: string]: string } = getParams(pathname, [ENTITY_PATH_ID, ENTITY_PATH]);
  const { data: packageData } = useGetPackageQuery({
    variables: {
      uuid: params.packageId
    },
    skip: !params.packageId,
    ...CACHE_FIRST
  });

  // useEffect(() => {
  //   if (params?.packageId && params?.versionUuid) {
  //     getPackage({
  //       variables: {
  //         uuid: params.packageId
  //       }
  //     });
  //   }
  // }, [pathname]);

  return (
    <Helmet>
      <title>
        {page ? `${page} | ` : ''}
        {packageData?.getPackage?.name ? `${packageData?.getPackage?.name} | ` : ''}
        {BASE_PAGE_TITLE}
      </title>
    </Helmet>
  );
};
